import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import { i18n } from './translate'

const ibantools = require('ibantools');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

extend('required', {
  ...rules['required'],
  message: (field) => {
    if (i18n.te(`validation.customRequired.${field}`))
      return i18n.t(`validation.customRequired.${field}`)
    return i18n.t(`validation.required`)
  }
});
extend('email', {
  ...rules['email'],
  message: () => i18n.t(`validation.email`)
})
extend('namesWithHyphensAndSpaces', {
  validate: value => {
    let regex = /^([\u0041-\u005A]|[\u0061-\u007A]|[\u00C0-\u02B7]|[\u0400-\u04FF]|[\u1E00-\u1EF0])+[\s|-]*([\u0041-\u005A]|[\u0061-\u007A]|[\u00C0-\u02B7]|[\u0400-\u04FF]|[\u1E00-\u1EF0])*$/g
    return regex.test(value);
  },
  message: () => i18n.t(`validation.name`)
});

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule] // copies rule configuration
    // message: wihtCustomMessages[rule] // assign message
  });
});


localize({
  en: {
    messages: en.messages
  }
});

localize(i18n.locale);


// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
Object.defineProperty(Vue.prototype, "locale", {
  get () {
    return i18n.locale;
  },
  set (val) {
    i18n.locale = val;
    localize(val);
  }
});
